import { useWizardSteps } from '@@/Stepper/useWizardSteps';
import { PageHeader } from '@@/PageHeader';

import { WizardStep, WizardProvider } from './WizardContext';
import { CreateForm } from './CreateForm';
import { ArtifactsStep } from './steps/ArtifactsStep';
import { SourceSelectStep } from './steps/SourceSelectStep';
import { ReviewStep } from './steps/ReviewStep';
import { ArtifactConfigStep } from './steps/ArtifactConfigStep/ArtifactConfigStep';

const steps: WizardStep[] = [
  SourceSelectStep,
  ArtifactsStep,
  ArtifactConfigStep,
  ReviewStep,
];

export function CreateView() {
  const context = useWizardSteps<WizardStep>({ steps });

  return (
    <div className="form-horizontal pb-20">
      <PageHeader
        title="Create Workflow"
        breadcrumbs={[
          { link: '.^', label: 'GitOps Workflows' },
          { label: 'Create Workflow' },
        ]}
        reload
      />

      <div className="row">
        <div className="col-sm-12">
          <WizardProvider context={context}>
            <CreateForm steps={steps} />
          </WizardProvider>
        </div>
      </div>
    </div>
  );
}
